import {types} from './types';

const initialState = {
    list: {
        data: [],
        countPage: 1
    },
    view: null
}

export function kycReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST:
            return { ...state, list: action.payload};
        default:
            return state
    }
}